import { useState } from 'preact/hooks';
import { activeEntries, partyRows, payableTotal, receivableTotal } from '@khata/core';
import { Chips, Empty, PageHead, Row } from '../components/index.js';
import { dShort, num, taka } from '../lib/format.js';
import { t } from '../lib/i18n.js';
import { entries, master, state } from '../lib/khata.js';
import { go } from '../lib/router.js';
import { openSheet } from '../lib/ui.js';

export function Parties() {
  const s = state.value;
  const m = master.value;
  const [tab, setTab] = useState<'customer' | 'vendor'>('customer');
  const rows = partyRows(s, m, tab);
  const recv = receivableTotal(s, m);
  const pay = payableTotal(s, m);
  const owing = partyRows(s, m, 'customer').filter((r) => r.balance > 0).length;
  const last = new Map<string, string>();
  for (const e of activeEntries(s, entries.value)) {
    const pid = 'partyId' in e ? e.partyId : null;
    if (pid && (!last.has(pid) || last.get(pid)! < e.date)) last.set(pid, e.date);
  }

  return (
    <>
      <PageHead
        title={t('parties_title')}
        sub={t('parties_sub', { n: num(owing), recv: taka(recv), pay: taka(pay) })}
      >
        <button
          type="button"
          class="btn btn-primary"
          onClick={() => openSheet({ kind: 'party', type: tab })}
        >
          {t('parties_add')}
        </button>
      </PageHead>
      <Chips
        options={[
          { key: 'customer', label: t('customers') },
          { key: 'vendor', label: t('vendors') },
        ]}
        value={tab}
        onChange={setTab}
      />
      <div class="list">
        {rows.length === 0 && (
          <Empty>
            {t('parties_empty', { type: t(tab === 'customer' ? 'customer' : 'vendor') })}
          </Empty>
        )}
        {rows.map((r) => (
          <Row
            key={r.party.id}
            title={r.party.name + (r.party.active ? '' : ` (${t('archived')})`)}
            sub={`${r.party.phone || r.party.note || '—'} · ${last.has(r.party.id) ? t('parties_last', { date: dShort(last.get(r.party.id)!) }) : t('parties_noActivity')}`}
            amount={taka(r.balance)}
            amountTone={r.status === 'due' ? (tab === 'customer' ? 'bad' : 'ink') : 'muted'}
            amountSub={
              r.status === 'due'
                ? tab === 'customer'
                  ? t('parties_owesYou')
                  : t('parties_youOwe')
                : r.status === 'advance'
                  ? t('parties_advance')
                  : t('parties_settled')
            }
            onClick={() => go('party', r.party.id)}
          />
        ))}
      </div>
    </>
  );
}
